import { TimezoneService } from './../../services/timezone.service';
import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { DataService } from '../../services/data.service';
import {
  faEngineWarning,
} from '@fortawesome/pro-light-svg-icons';
import { AuthStateService } from '../../services/auth-state.service';
import { TranslocoService } from '@ngneat/transloco';
import { Subscription, forkJoin } from 'rxjs';
import { DOCUMENT } from '@angular/common';
import { UiService } from '../../services/ui.service';
import { AcMainState, AppService } from '../../services/app.service';
import { AcModel } from '../../models/ac.model';
import { Router } from '@angular/router';

@Component({
  selector: 'app-ac',
  templateUrl: './ac.component.html',
  styleUrls: ['./ac.component.scss']
})
export class AcComponent implements OnInit, OnDestroy {

  public loading = true;
  public error = false;
  public acSubscription: Subscription = null;

  public faEngineWarning = faEngineWarning;

  constructor(
    private app: AppService,
    private router: Router,
    private data: DataService,
    private timezone: TimezoneService,
    private auth: AuthStateService,
    private transloco: TranslocoService,
    private ui: UiService,
    @Inject(DOCUMENT) private document: Document
  ) { }

  ngOnInit(): void {
    this.acSubscription = this.app.ac$.subscribe((acState: AcMainState) => {
      this.loading = acState.loading;
      if (acState.ac !== null) {
        this.prepareAc(acState.ac);
      } else if (acState.error) {
        switch (acState.error.status) {
          case (401): {
            this.auth.logout();
            break;
          }
          case (404): {
            this.app.set404();
            break;
          }
          default: {
            this.error = true;
            break;
          }
        }
      }
    });
    forkJoin([
      this.transloco.load('en'),
      this.transloco.load('de'),
    ]).subscribe({
      next: () => {
        this.app.loadAc();
      }
    });
  }

  ngOnDestroy(): void {
    this.data.setPolling(false);
    if (this.acSubscription !== null) {
      this.acSubscription.unsubscribe();
    }
  }

  logoutAndGotoLogin(): void {
    this.auth.logout();
    this.router.navigate(['/login']);
  }

  private prepareAc(ac: AcModel): void {
    const language = ac.language?.toLowerCase();
    this.data.setAc(ac);
    this.data.setPolling(true);
    this.timezone.setTimezones(ac);
    this.document.documentElement.lang = language;
    this.transloco.setActiveLang(language);
    this.loading = false;
    // show copyright info
    if (this.auth.isCandidate() || this.auth.isObserver()) {
      setTimeout(() => {
        if (!this.app.isCopyRightShown()) {
          this.ui.showCopyrightInfo();
        }
        this.app.setCopyRightShown();
      }, 1000);
    }
  }

}
